import { GetEmployeeRelatorioUnicoFieldsDocument } from 'generated/resources/graphql'
import type { TrainingsEmployeeRelatorioUnicoField } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useEmployeeRelatorioUnicoFields = (employeeId: number) => {
  const { loading, data } = useQuery(GetEmployeeRelatorioUnicoFieldsDocument, {
    variables: {
      employeeId: employeeId,
    },
  })

  return {
    loading,
    employeeRelatorioUnicoField: data
      ? data.trainings.employeeRelatorioUnicoFieldsConnection.nodes.at(0)
      : undefined,
  }
}

export type EmployeeRelatorioUnicoField = TrainingsEmployeeRelatorioUnicoField
